import { Navigate } from 'react-router-dom';

// AdminMaster ha sido dividido en páginas separadas
// Redirige a la página de usuarios
const AdminMaster = () => {
  return <Navigate to="/admin/usuarios" replace />;
};

export default AdminMaster;
